module.exports = __webpack_public_path__ + "img/hagerup_Familieportrett1.235e27a5.jpg";